/**
 * @zag/locations/models
 *
 * Shared Arktype model schemas for locations domain.
 * This library contains:
 * - ArkType model schemas (for API validation)
 * - Type definitions for REST API contract between backend and frontend
 */

export * from './models';
export * from './lib/locations.features';
